module.exports = __webpack_public_path__ + "static/portfolio-71bdd836c55376aec8a0f2f7cae0c60e.pdf";